var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import API from '../../util/ApiUtil';
export default class PersonAddressStore {
    constructor(rootStore) {
        Object.defineProperty(this, "primeContactAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "customerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                const addresses = response.data;
                if (!addresses.length) {
                    this.status = 'FETCHED';
                    return;
                }
                this.primeContactAddress = addresses.find((p) => p.prime);
                this.status = 'FETCHED';
            }
        });
        Object.defineProperty(this, "onError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                this.primeContactAddress = null;
                this.status = 'ERROR';
                console.error(e);
            }
        });
        Object.defineProperty(this, "shouldLoadNewData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (customerId) => {
                return this.customerId !== customerId || ['UNINITIALIZED', 'ERROR'].includes(this.status);
            }
        });
        makeObservable(this);
        this.ssoStore = rootStore.ssoStore;
    }
    async loadPersonAddress() {
        if (!this.shouldLoadNewData(this.ssoStore.customerId)) {
            return Promise.resolve();
        }
        this.customerId = this.ssoStore.customerId;
        return this.fetchPersonAddress();
    }
    fetchPersonAddress() {
        this.status = 'FETCHING';
        return API.get('/person-data/address/get').then(this.onSuccess).catch(this.onError);
    }
    get isFetching() {
        return ['UNINITIALIZED', 'FETCHING'].includes(this.status);
    }
}
__decorate([
    observable
], PersonAddressStore.prototype, "primeContactAddress", void 0);
__decorate([
    observable
], PersonAddressStore.prototype, "customerId", void 0);
__decorate([
    observable
], PersonAddressStore.prototype, "status", void 0);
__decorate([
    action.bound
], PersonAddressStore.prototype, "loadPersonAddress", null);
__decorate([
    action.bound
], PersonAddressStore.prototype, "fetchPersonAddress", null);
__decorate([
    action.bound
], PersonAddressStore.prototype, "onSuccess", void 0);
__decorate([
    action.bound
], PersonAddressStore.prototype, "onError", void 0);
__decorate([
    computed
], PersonAddressStore.prototype, "isFetching", null);
